import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

//import { OAuthStorage } from "angular-oauth2-oidc";
import { OAuthService } from "angular-oauth2-oidc";
//import { AuthService } from "../shared/auth.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private authservice: OAuthService) {}
    
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes("https://sasser.okta.com")) {
      return next.handle(req);
    }

    const userToken = this.authservice.getIdToken();
    
    const modifiedReq = req.clone({ 
      headers: req.headers.set('Authorization', `Bearer ${userToken}`),
    });
    
    return next.handle(modifiedReq);
  }
}